<form [formGroup]="juridicoForm" (ngSubmit)="validateForm()">
  <div class="myForm">
    @if (currentStep === 1) {
    <!-- Sección 1: Información general / Datos generales -->
    <div class="form-section-header mb-2">
      <h3 class="form-section-header__title">Información general</h3>
      <p class="form-section-header__subtitle mt-3">
        <img src="assets/img/Inicio_sesion/svg/Ico_Datos_Generales.svg"
          alt="" class="form-section-header__icon" aria-hidden="true" />
        Datos generales
      </p>
    </div>
    <div class="form-fields-flow mt-3">
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ err: validateField('razonSocial') }">
          <label for="razonSocial" class="form-label">Razón social</label>
          <input
            type="text"
            maxlength="100"
            class="form-control"
            formControlName="razonSocial"
            id="razonSocial"
            placeholder="Digita Razón social"
            (change)="autorizarDatos()"
            appNextFieldId="numeroDocumento"
            [ngClass]="{ 'is-invalid': validateField('razonSocial') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ err: validateField('numeroDocumento') }">
          <label for="numeroDocumento" class="form-label">NIT</label>
          <input
            type="text"
            minlength="9"
            maxlength="9"
            class="form-control"
            formControlName="numeroDocumento"
            id="numeroDocumento"
            placeholder="Digita NIT"
            (keypress)="validateNumber($event)"
            (change)="autorizarDatos()"
            appNextFieldId="confirmNit"
            [ngClass]="{ 'is-invalid': validateField('numeroDocumento') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('confirmNit') || juridicoForm.controls.confirmNit?.hasError('confirmNumeroDocumentoMatch') }">
          <label for="confirmNit" class="form-label">Confirma tu número de NIT</label>
          <input
            type="text"
            class="form-control"
            formControlName="confirmNit"
            id="confirmNit"
            placeholder="Digita NIT"
            minlength="9"
            maxlength="9"
            (keypress)="validateNumber($event)"
            oncopy="return false"
            onpaste="return false"
            appNextFieldId="camaraSi"
            [ngClass]="{ 'is-invalid': validateField('confirmNit') || juridicoForm.controls.confirmNit?.hasError('confirmNumeroDocumentoMatch') }"
            aria-describedby="confirmNit-error"
            required
          />
          <div class="invalid-feedback d-block" id="confirmNit-error" *ngIf="juridicoForm.controls.confirmNit?.hasError('confirmNumeroDocumentoMatch')">
            El número de NIT no coincide
          </div>
          <div class="invalid-feedback d-block" *ngIf="validateField('confirmNit') && !juridicoForm.controls.confirmNit?.hasError('confirmNumeroDocumentoMatch')">
            Campo obligatorio
          </div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('digitoVerificacion') }">
          <label for="digitoVerificacion" class="form-label">DV</label>
          <input
            type="text"
            maxlength="1"
            class="form-control"
            formControlName="digitoVerificacion"
            id="digitoVerificacion"
            placeholder="Se calcula automáticamente"
            [ngClass]="{ 'is-invalid': validateField('digitoVerificacion') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': juridicoForm.get('camaraComercioVigente')?.invalid }">
          <span class="form-label d-block" id="camara-label">¿Cuentas con cámara de comercio vigente?</span>
          <div class="form-check form-check-inline">
            <input [value]="1" type="radio" class="form-check-input" id="camaraSi"
              formControlName="camaraComercioVigente" name="camaraComercioVigente"
              appNextFieldId="anioVentas"
              [ngClass]="{ 'is-invalid': juridicoForm.get('camaraComercioVigente')?.invalid }"
              aria-labelledby="camara-label camaraSi-label" />
            <label for="camaraSi" class="form-check-label" id="camaraSi-label" [ngClass]="{ 'text-danger': juridicoForm.get('camaraComercioVigente')?.invalid }">Sí</label>
          </div>
          <div class="form-check form-check-inline">
            <input [value]="0" type="radio" class="form-check-input" id="camaraNo"
              formControlName="camaraComercioVigente" name="camaraComercioVigente"
              appNextFieldId="anioVentas"
              [ngClass]="{ 'is-invalid': juridicoForm.get('camaraComercioVigente')?.invalid }"
              aria-labelledby="camara-label camaraNo-label" />
            <label for="camaraNo" class="form-check-label" id="camaraNo-label" [ngClass]="{ 'text-danger': juridicoForm.get('camaraComercioVigente')?.invalid }">No</label>
          </div>
          <div class="invalid-feedback d-block" *ngIf="juridicoForm.get('camaraComercioVigente')?.invalid">Campo obligatorio</div>
        </div>
      </div>
    </div>

    <!-- Sección 2: Información financiera -->
    <div class="form-section-header mb-2 mt-4">
      <p class="form-section-header__subtitle mt-3">
        <img src="assets/img/Inicio_sesion/svg/Ico_Info_Financiera.svg"
          alt="" class="form-section-header__icon" aria-hidden="true" />
        Información financiera
      </p>
    </div>
    <div class="form-fields-flow mt-3">
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('anioVentas') }">
          <label for="anioVentas" class="form-label">Año de ventas</label>
          <select
            class="form-control"
            formControlName="anioVentas"
            id="anioVentas"
            appNextFieldId="valorVentas"
            [ngClass]="{ 'is-invalid': validateField('anioVentas'), 'placeholder-selected': !juridicoForm.get('anioVentas').value }"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona año de ventas</option>
            @for (anio of anios; track anio) {
              <option [value]="anio">{{ anio }}</option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('valorVentas') }">
          <label for="valorVentas" class="form-label">Ventas del último año</label>
          <input
            type="text"
            maxlength="17"
            class="form-control"
            formControlName="valorVentas"
            id="valorVentas"
            placeholder="Digita ventas del último año"
            appNextFieldId="idDepartamento"
            (keypress)="validateNumber($event)"
            [ngClass]="{ 'is-invalid': validateField('valorVentas') }"
            required
            (keyup)="validarVentaAnual()"
          />
          <div class="invalid-feedback">{{ msjErrorValorVentas }}</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idDepartamento') }">
          <label for="idDepartamento" class="form-label">Departamento donde está tu negocio</label>
          <select
            class="form-control selectpicker"
            data-live-search="true"
            data-width="100%"
            data-size="5"
            #idDepartamento
            id="idDepartamento"
            title="Selecciona departamento"
            formControlName="idDepartamento"
            (change)="getCambio($event)"
            [ngClass]="{ 'is-invalid': validateField('idDepartamento') }"
            appNextFieldId="idCiudad"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona departamento</option>
            @for (departamento of departamentos; track departamento) {
              <option [value]="departamento.idDepartamento">
                {{ departamento.nombreDepartamento }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo es obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idCiudad') }">
          <label for="idCiudad" class="form-label">Ciudad donde está tu negocio</label>
          <select
            #idCiudad
            id="idCiudad"
            class="form-control selectpicker"
            data-live-search="true"
            data-width="100%"
            data-size="5"
            formControlName="idCiudad"
            title="Selecciona ciudad"
            (change)="onCiudadChange()"
            [ngClass]="{ 'is-invalid': validateField('idCiudad') }"
            [appNextFieldId]="juridicoForm.get('idCiudad').value == idBogota ? 'idLocalidad' : 'codigoCiiu'"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona ciudad</option>
            @for (ciudad of ciudades; track ciudad) {
              <option [value]="ciudad.idCiudad">
                {{ ciudad.nombreCiudad }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo es obligatorio</div>
        </div>
      </div>
      @if (juridicoForm.get('idCiudad').value == idBogota) {
        <div class="form-field-item">
          <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('idLocalidad') }">
            <label for="idLocalidad" class="form-label">Localidad donde está ubicado tu negocio</label>
            <select
              #idLocalidad
              id="idLocalidad"
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              formControlName="idLocalidad"
              title="Selecciona localidad"
              (change)="selectpikerChange('idLocalidad')"
              [ngClass]="{ 'is-invalid': validateField('idLocalidad') }"
              appNextFieldId="codigoCiiu"
            >
              <option [value]="''" class="option-placeholder">Selecciona localidad</option>
              @for (loc of localidades; track loc) {
                <option [value]="loc.id">
                  {{ loc.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
      }
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }">
          <label for="codigoCiiu" class="form-label">Actividad económica</label>
          <select
            id="codigoCiiu"
            class="form-control selectpicker"
            [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }"
            data-live-search="true"
            formControlName="codigoCiiu"
            required
            data-size="6"
            appNextFieldId="tiposContacto"
            (change)="selectpikerChange('codigoCiiu')"
            title="Selecciona actividad económica"
          >
            <option [value]="''" class="option-placeholder">Selecciona actividad económica</option>
            @for (ciiu of ciius; track ciiu) {
              <option [value]="ciiu.codigoCiiu" [attr.data-tokens]="ciiu.codigoCiiu">
                {{ ciiu.codigoCiiu }} - {{ ciiu.nombreCiiu }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('tiposContacto') }">
          <label for="tiposContacto" class="form-label">¿Cómo desea ser contactado?</label>
          <select
            id="tiposContacto"
            class="form-control selectpicker"
            [ngClass]="{ 'is-invalid': validateField('tiposContacto') }"
            data-live-search="true"
            formControlName="tiposContacto"
            required
            data-size="4"
            multiple
            appNextFieldId="personaDeContacto"
            data-actions-box="true"
            data-select-all-text="<i class='fas fa-plus'></i> Seleccionar todos"
            data-deselect-all-text="<i class='fas fa-minus'></i> Quitar todos"
            (change)="selectpikerChangeContactos('tiposContacto')"
            title="Selecciona una opción"
          >
            @for (tipo of listaTiposCont; track tipo) {
              <option [value]="tipo.idTipoContacto">
                {{ tipo.nombre }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center align-items-center mt-3 registro-nav-buttons">
      <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
        <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
          <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
          <span class="btn-registro-nav__text">Anterior</span>
        </button>
        <button
          type="button"
          class="btn-registro-nav btn-registro-nav--next"
          [disabled]="!isStep1Valid()"
          (click)="goToNextStep()"
        >
          <span class="btn-registro-nav__text">Siguiente</span>
          <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
        </button>
      </div>
    </div>
    }

    @if (currentStep === 2) {
    <!-- Sección 3: Información de contacto / Datos de contacto -->
    <div class="form-section-header mb-3">
      <h3 class="form-section-header__title">Información de contacto</h3>
      <p class="form-section-header__subtitle mt-3">
        <img src="assets/img/Inicio_sesion/svg/Ico_Datos_Generales.svg"
          alt="" class="form-section-header__icon" aria-hidden="true" />
        Datos de contacto
      </p>
    </div>
    <div class="form-fields-flow mt-4">
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('personaDeContacto') }">
          <label for="personaDeContacto" class="form-label">Persona de contacto</label>
          <select
            class="form-control"
            formControlName="personaDeContacto"
            id="personaDeContacto"
            [ngClass]="{ 'is-invalid': validateField('personaDeContacto'), 'placeholder-selected': !juridicoForm.get('personaDeContacto').value }"
            (change)="setValidators()"
            [appNextFieldId]="juridicoForm.get('personaDeContacto').value === 'Otros' ? 'tipoPersonaOtro' : 'primerNombre'"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona una opción</option>
            <option [ngValue]="'Representante legal'">Representante legal</option>
            <option [ngValue]="'Gerente'">Gerente</option>
            <option [ngValue]="'Otros'">Otros</option>
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      @if (juridicoForm.get('personaDeContacto').value === 'Otros') {
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('tipoPersonaOtro') }">
            <label for="tipoPersonaOtro" class="form-label" [ngClass]="{ 'text-danger': validateField('tipoPersonaOtro') }">Cargo</label>
            <input
              type="text"
              class="form-control toCapitalizeWords"
              maxlength="30"
              appOnlyLetters
              formControlName="tipoPersonaOtro"
              id="tipoPersonaOtro"
              placeholder="Digita cargo"
              (keyup)="validarTexto($event)"
              appNextFieldId="primerNombre"
              [ngClass]="{ 'is-invalid': validateField('tipoPersonaOtro') }"
              required
            />
            <div class="invalid-feedback d-block" *ngIf="validateField('tipoPersonaOtro')">Campo obligatorio</div>
          </div>
        </div>
      }
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ err: validateField('primerNombre') }">
          <label for="primerNombre" class="form-label">Primer nombre</label>
          <input
            type="text"
            class="form-control toCapitalizeWords"
            maxlength="20"
            formControlName="primerNombre"
            id="primerNombre"
            placeholder="Digita primer nombre"
            appOnlyLetters
            (keyup)="validarTexto($event)"
            appNextFieldId="segundoNombre"
            [ngClass]="{ 'is-invalid': validateField('primerNombre') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3">
          <label for="segundoNombre" class="form-label">Segundo nombre</label>
          <input
            type="text"
            class="form-control toCapitalizeWords"
            maxlength="20"
            formControlName="segundoNombre"
            id="segundoNombre"
            placeholder="Digita segundo nombre"
            appOnlyLetters
            (keyup)="validarTexto($event)"
            appNextFieldId="primerApellido"
          />
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ err: validateField('primerApellido') }">
          <label for="primerApellido" class="form-label">Primer apellido</label>
          <input
            id="primerApellido"
            type="text"
            class="form-control toCapitalizeWords"
            maxlength="20"
            formControlName="primerApellido"
            placeholder="Digita primer apellido"
            appOnlyLetters
            appNextFieldId="segundoApellido"
            (keyup)="validarTexto($event)"
            [ngClass]="{ 'is-invalid': validateField('primerApellido') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3">
          <label for="segundoApellido" class="form-label">Segundo apellido</label>
          <input
            type="text"
            class="form-control toCapitalizeWords"
            maxlength="20"
            formControlName="segundoApellido"
            id="segundoApellido"
            placeholder="Digita segundo apellido"
            appOnlyLetters
            (keyup)="validarTexto($event)"
            appNextFieldId="idTipoDocIdentidad"
          />
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad') }">
          <label for="idTipoDocIdentidad" class="form-label">Tipo de documento</label>
          <select
            class="form-control"
            formControlName="idTipoDocIdentidad"
            id="idTipoDocIdentidad"
            [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad'), 'placeholder-selected': !juridicoForm.get('idTipoDocIdentidad').value }"
            (change)="validarSelect()"
            [appNextFieldId]="juridicoForm.get('idTipoDocIdentidad').value !== '2' ? 'idPaisOrigen' : 'numeroDocumentoP'"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona tipo documento</option>
            @for (documento of documentos; track documento) {
              <option [value]="documento.idTipoDocIdentidad">
                {{ documento.nombre }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      @if (isPasaporte) {
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }">
            <label for="idPaisOrigen" class="form-label">¿Cuál es tu nacionalidad?</label>
            <select
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              #idPaisOrigen
              id="idPaisOrigen"
              title="Selecciona país"
              formControlName="idPaisOrigen"
              appNextFieldId="numeroDocumentoP"
              (change)="selectpikerChange('idPaisOrigen')"
              [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona país</option>
              @for (pais of paises; track pais) {
                <option [value]="pais.idPais">
                  {{ pais.nombrePais }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
      }
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroDocumentoP') }">
          <label for="numeroDocumentoP" class="form-label">Número de documento</label>
          <input
            type="text"
            class="form-control"
            formControlName="numeroDocumentoP"
            id="numeroDocumentoP"
            placeholder="Digita documento"
            maxlength="15"
            appNumeroDocumentoPorTipo
            [idTipoDocControlName]="'idTipoDocIdentidad'"
            [tipos]="documentos"
            (change)="autorizarDatos()"
            appNextFieldId="confirmNumeroDocumento"
            [ngClass]="{ 'is-invalid': validateField('numeroDocumentoP') }"
            aria-describedby="numeroDocumentoP-error"
            required
          />
          <div class="invalid-feedback d-block" id="numeroDocumentoP-error" *ngIf="validateField('numeroDocumentoP')">
            {{ juridicoForm.get('numeroDocumentoP').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('numeroDocumentoP') }}
          </div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }">
          <label for="confirmNumeroDocumento" class="form-label">Confirma tu número de documento</label>
          <input
            type="text"
            class="form-control"
            formControlName="confirmNumeroDocumento"
            id="confirmNumeroDocumento"
            placeholder="Digita nuevamente documento"
            maxlength="15"
            appNumeroDocumentoPorTipo
            [idTipoDocControlName]="'idTipoDocIdentidad'"
            [tipos]="documentos"
            [allowPaste]="false"
            oncopy="return false"
            onpaste="return false"
            appNextFieldId="idGenero"
            [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }"
            aria-describedby="confirmNumeroDocumentoP-error mensaje-error-confirmNumeroDocumentoP"
            required
          />
          <div class="invalid-feedback d-block" id="confirmNumeroDocumentoP-error" *ngIf="juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
            Los números de documento no coinciden
          </div>
          <div class="invalid-feedback d-block" id="mensaje-error-confirmNumeroDocumentoP" *ngIf="validateField('confirmNumeroDocumento') && !juridicoForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
            {{ juridicoForm.get('confirmNumeroDocumento').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('confirmNumeroDocumento') }}
          </div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idGenero') }">
          <label for="idGenero" class="form-label">Género</label>
          <select
            id="idGenero"
            class="form-control"
            formControlName="idGenero"
            appNextFieldId="numeroCelular"
            [ngClass]="{ 'is-invalid': validateField('idGenero'), 'placeholder-selected': !juridicoForm.get('idGenero').value }"
            required
          >
            <option [value]="''" class="option-placeholder">Selecciona género</option>
            @for (genero of generos; track genero) {
              <option [value]="genero.idGenero">
                {{ genero.nombre }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroCelular') }">
          <label for="numeroCelular" class="form-label">Número de celular</label>
          <input
            type="text"
            class="form-control"
            maxlength="10"
            formControlName="numeroCelular"
            id="numeroCelular"
            placeholder="Digita número de celular"
            (keypress)="validateNumber($event)"
            appNextFieldId="numeroOpcional"
            [ngClass]="{ 'is-invalid': validateField('numeroCelular') }"
            required
          />
          <div class="invalid-feedback">Campo obligatorio. Máximo 10 dígitos.</div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3">
          <label for="numeroOpcional" class="form-label">Número de celular opcional</label>
          <input
            type="text"
            class="form-control"
            minlength="7"
            maxlength="10"
            formControlName="numeroOpcional"
            id="numeroOpcional"
            placeholder="Digita número opcional"
            (keypress)="validateNumber($event)"
            appNextFieldId="minoriaSi"
          />
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3">
          <span class="form-label d-block" id="minoria-label">¿Pertenece a alguna minoría?</span>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="minoria" [value]="1"
              id="minoriaSi" aria-labelledby="minoria-label minoriaSi-label"
              appNextFieldId="minoriaDescripcion"
              (click)="validarMinoria(1)" (keydown.enter)="validarMinoria(1)" />
            <label class="form-check-label" id="minoriaSi-label" for="minoriaSi">Sí</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" formControlName="minoria" [value]="0"
              id="minoriaNo" aria-labelledby="minoria-label minoriaNo-label"
              appNextFieldId="correoElectronico"
              (click)="validarMinoria(0)" (keydown.enter)="validarMinoria(0)" />
            <label class="form-check-label" id="minoriaNo-label" for="minoriaNo">No</label>
          </div>
        </div>
      </div>
      @if (juridicoForm.get('minoria').value === 1) {
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('minoriaDescripcion') }">
            <label for="minoriaDescripcion" class="form-label">¿Qué tipo de minoría?</label>
            <input
              type="text"
              class="form-control"
              id="minoriaDescripcion"
              formControlName="minoriaDescripcion"
              placeholder="Digita tipo de minoría"
              appNextFieldId="correoElectronico"
              [ngClass]="{ 'is-invalid': validateField('minoriaDescripcion') }"
            />
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
      }
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ err: validateField('correoElectronico') }">
          <label for="correoElectronico" class="form-label">Correo electrónico</label>
          <input
            type="email"
            class="form-control"
            maxlength="50"
            formControlName="correoElectronico"
            placeholder="Digita correo electrónico"
            (input)="juridicoForm.get('correoElectronico').setValue($event.target.value.toLowerCase())"
            appNextFieldId="idFuenteNeocredito"
            [ngClass]="{ 'is-invalid': validateField('correoElectronico') }"
            id="correoElectronico"
            required
          />
          <div class="invalid-feedback d-block" *ngIf="validateField('correoElectronico')">
            {{ getCorreoElectronicoErrorMessage() }}
          </div>
        </div>
      </div>
      <div class="form-field-item">
        <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }">
          <label for="idFuenteNeocredito" class="form-label">¿Cómo te enteraste de neocrédito?</label>
          <select
            #idFuenteNeocredito
            id="idFuenteNeocredito"
            class="form-control selectpicker"
            [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }"
            data-live-search="true"
            formControlName="idFuenteNeocredito"
            required
            data-size="6"
            [appNextFieldId]="isReferido ? 'nombreReferido' : (isOtraFuente ? 'otraFuente' : 'tratamientoDatos')"
            (change)="valueSelected(juridicoForm.get('idFuenteNeocredito').value)"
            title="Selecciona una opción"
          >
            <option [value]="''" class="option-placeholder">Selecciona una opción</option>
            @for (elemento of fuentesInformacion; track elemento) {
              <option [value]="elemento.idFuenteNeocredito">
                {{ elemento.fuente }}
              </option>
            }
          </select>
          <div class="invalid-feedback">Campo obligatorio</div>
        </div>
      </div>
      @if (isReferido) {
        <div class="form-field-item">
          <div class="mb-3">
            <label for="nombreReferido" class="form-label">¿Quién te refirió?</label>
            <input
              type="text"
              class="form-control"
              maxlength="60"
              formControlName="nombreReferido"
              id="nombreReferido"
              placeholder="Digita nombre"
              appNextFieldId="codigoReferido"
            />
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3">
            <label for="codigoReferido" class="form-label">Código del referido</label>
            <input
              type="text"
              class="form-control"
              id="codigoReferido"
              maxlength="20"
              autocomplete="off"
              formControlName="codigoReferido"
              placeholder="Digita código"
              [appNextFieldId]="isOtraFuente ? 'otraFuente' : 'tratamientoDatos'"
            />
          </div>
        </div>
      }
      @if (isOtraFuente) {
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('otraFuente') }">
            <label for="otraFuente" class="form-label">¿Cuál?</label>
            <input
              type="text"
              class="form-control"
              autocomplete="off"
              maxlength="250"
              formControlName="otraFuente"
              id="otraFuente"
              placeholder="Especifica cómo te enteraste"
              appNextFieldId="tratamientoDatos"
              [ngClass]="{ 'is-invalid': validateField('otraFuente') }"
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
      }
    </div>

    @if (isAutorizarDatos) {
      <div class="politicas mt-3">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="tratamientoDatos"
            [ngClass]="{ 'is-invalid': validateField('tratamientoDatos') }"
            formControlName="tratamientoDatos"
          />
          <label for="tratamientoDatos" class="form-check-label">
            Al seleccionar, aceptas nuestra
            <span
              (click)="showModal('P')"
              (keydown.enter)="showModal('P')"
              data-bs-target="#politicasModal"
              data-bs-toggle="modal"
              >política de tratamiento de datos personales.</span
            >
          </label>
        </div>
      </div>
    }

    <div class="row justify-content-center align-items-center mt-3 mb-3 registro-nav-buttons">
      <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
        <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
          <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
          <span class="btn-registro-nav__text">Anterior</span>
        </button>
        <button type="button" class="btn-registro-nav btn-registro-nav--next" disabled>
          <span class="btn-registro-nav__text">Siguiente</span>
          <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
        </button>
      </div>
    </div>
    <div class="row justify-content-center mt-4 mb-3">
      <div class="col-auto">
        <button class="btn-registro-nav btn-registro-nav--finish" type="submit" [disabled]="!isStep2Ready()">
          <span class="btn-registro-nav__text">Actualizar datos</span>
          <img src="assets/img/Inicio_sesion/svg/Ico_Finalizar_registro.svg" alt="" class="btn-registro-nav__icon-img" aria-hidden="true" />
        </button>
      </div>
    </div>
    }
  </div>
</form>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<politicas-modal [title]="titleModal"></politicas-modal>
